export default __webpack_public_path__ + "static/media/OBESITY.f11d2065.png";